import React, {
  Component
} from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';

export default class Pinregistration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount() {
    const url=window.location.href;
    var lr_id=url.split('=');
    if(lr_id['1'] && lr_id['1']!="")
    {
    Common.reactLoader("show", "Please wait...");
    fetch(Config.domainUrl +"user/getregisterdetails", {
      method: "POST",
      headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json'
      },
      body: JSON.stringify({
       lr_id:lr_id['1']
      })
     }).then((response) => response.json()).then((responseJson) => {
      Common.reactLoader("hide");
      if (responseJson.status === 0) {
        if(responseJson.errors!=""){

          Common.message(responseJson.message,responseJson.errors,'error');
         }else{
          Common.message("Oops!!",responseJson.message,'error');
         }
      }
      else if(responseJson.status === 1)
      {
        document.getElementById('email').value=responseJson.data.user_name;
        document.getElementById('pin').value=responseJson.data.pinno;
        document.getElementById('Key').value=responseJson.data.user_key;
        
      }
     });  
    }
  }
  handleChange(e){
    this.props.onChange(e);
  }

  submit(){
    this.props.submit();
  }

  backToPreviousPage(){
    this.props.backToPreviousPage();
  }
  

  render() {

  
    return (
     <div>
     <h1>PIN Registration</h1>
     If you have received an email with your PIN number, please register here.
     <div className="gray-box">
       <div className="img-box"><img src={process.env.PUBLIC_URL+'/images/img-pinreg.jpg'} alt="" border="0"/></div>
       <div className="pin-form">
         <div>

             Username
                 <input type="text" maxLength="100" id="email" name="email" onChange={e=>this.handleChange(e)}/>

               PIN
                 <input type="text" maxLength="45" id="pin" name="pin" onChange={e=>this.handleChange(e)} />

               Key
                 <input type="text" name="key" id="Key" onChange={e=>this.handleChange(e)}/>


               <input type="button" className="grn-btn" value="Next" alt="Next" onClick={(e)=>this.submit()} title="Next"/>
             &nbsp;
             <input type="button" name="red-btn" onClick={(e)=>this.backToPreviousPage()} value="Cancel" alt="Cancel" title="Cancel"  className="button-cancel"/>

         </div>
       </div>
     </div>
     </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/auth/Pinregistration.js